// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__GUGFP","go-home":"styles_go-home__3Pvd0","thank-you":"styles_thank-you__38N-3","elements":"styles_elements__SlhBB","container":"styles_container__1jTM-"};